<template>
  <el-row class="c-grid" :class="{bord:bord}">
    <slot>
      <c-grid-item :gridItems="gridItems" />
    </slot>
  </el-row>
</template>

<script>
  import CGridItem from './src/CGridItem.vue';

  export default {
    components: {
      CGridItem
    },
    props: {
      value: Object,
      span: {
        type: Number,
        default: 6
      },
      bord: Boolean,
      gridItems: Array,
    },
    provide() {
      return {
        cGrid: this
      }
    }
  }
</script>

<style>
  .c-grid .el-col {
    padding: 20px 10px;
  }

  .c-grid.bord {
    border-top: solid 1px #E4E7ED;
    border-left: solid 1px #E4E7ED;
  }

  .c-grid.bord .el-col {
    padding: 0;
    border-right: solid 1px #E4E7ED;
    border-bottom: solid 1px #E4E7ED;
  }

  .c-grid.bord .c-grid-item-bord span:first-child {
    padding: 15px 20px;
    border-right: solid 1px #E4E7ED;
  }
</style>
